angular.module('picmonicng').directive('factHotbox', [
  '$state',
  'LearnService',
  function ($state, LearnService) {
    return {
      restrict: 'AE',
      template: '<canvas class="fact-hotbox" ng-class="{blur: blur}"></canvas>',
      scope: {
        image: '=',
        size: '@',
        fact: '=',
        blur: '=',
      },
      link: function (scope, element, attrs) {
        var img;
        var canvas = element.find('canvas')[0];
        var ctx = canvas.getContext('2d');

        switch (scope.size) {
          case 'full':
            scope.directory = 'images_panel';
            break;
          case 'medium':
            scope.directory = 'images_panel_tablet';
            break;
          case 'small':
            scope.directory = 'images_panel_mobile';
            break;
          default:
            scope.directory = 'images_panel';
            break;
        }

        scope.$watch(
          function () {
            return scope.image;
          },
          function () {
            if (scope.image) {
              img = new Image();
              img.src = '/cloud_data/' + scope.directory + '/' + scope.image;
              img.crossOrigin = 'anonymous';

              img.addEventListener('load', function () {
                scope.native_width = img.width;
                scope.native_height = img.height;
                canvas.width = scope.fact.hotbox_width;
                canvas.height = scope.fact.hotbox_height;
                drawHotbox();

                scope.$watch(
                  function () {
                    return scope.fact;
                  },
                  function () {
                    if (scope.fact.fact_id) {
                      canvas.width = scope.fact.hotbox_width;
                      canvas.height = scope.fact.hotbox_height;
                      drawHotbox();
                    }
                  }
                );
              });
            }
          }
        );

        function drawHotbox() {
          ctx.drawImage(
            img,
            scope.fact.hotbox_x * (scope.native_width / 2200),
            scope.fact.hotbox_y * (scope.native_height / 1700),
            scope.fact.hotbox_width * (scope.native_width / 2200),
            scope.fact.hotbox_height * (scope.native_height / 1700),
            0,
            0,
            canvas.width,
            canvas.height
          );
        }
      },
    };
  },
]);
